// Copia o código da variável para a área de transferência
(function () {
  'use strict';
  if ($('.cd-vr-code:not(.in-modal)').length > 0) {
    const clipboard = new ClipboardJS('.cd-vr-code:not(.copied)');
    clipboard.on('success', function (ev) {
      const triggerEl = ev.trigger;
      triggerEl.classList.add('copied');
      triggerEl.innerHTML = '<i class="las la-check"></i>Copiada';
      setTimeout(() => {
        triggerEl.classList.remove('copied');
        triggerEl.innerHTML = triggerEl.dataset.clipboardText;
      }, 1500);
    });
  }
  if ($('.modal.init-clipboard').length > 0) {
    $('.modal.init-clipboard').each(function () {
      const $modal = $(this);
      $modal.on('shown.bs.modal', function () {
        const clipboard = new ClipboardJS('.cd-vr-code:not(.copied)', {
          container: document.getElementById($modal.attr('id')),
        });
        clipboard.on('success', function (ev) {
          const triggerEl = ev.trigger;
          triggerEl.classList.add('copied');
          triggerEl.innerHTML = '<i class="las la-check"></i>Copiada';
          setTimeout(() => {
            triggerEl.classList.remove('copied');
            triggerEl.innerHTML = triggerEl.dataset.clipboardText;
          }, 1500);
        });
      });
    });
  }
})();
